import { useEffect } from 'react';

import { FormResponse } from 'components/Form/FormResponse/FormResponse';

import { useGetReferenceCandidateResponseQuery } from 'api/candidates-api';

export const CandidateAnswers = ({ candidate, referee, setLoading = () => {} }) => {
  const { data: response, isLoading } = useGetReferenceCandidateResponseQuery({
    id: candidate.id,
    refereeId: referee.id,
  });

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  return (
    <div className="border-b border-neutral-4">
      <FormResponse
        form={response?.form}
        answers={response?.answers}
        flagSeverities={response?.flag_severities}
        params={{
          candidate: candidate.first_name,
          candidateFirstName: candidate.first_name,
          candidateFullName: candidate.name,
          candidateLastName: candidate.last_name,
          job: candidate.job_role,
          department: candidate.department,
        }}
      />
    </div>
  );
};
